import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Icons } from "src/util/enums/fontAwesomeIcons"
import { computed, ref, watchEffect } from "vue"
import SfxInput from "./SfxInput.vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxInputPassword',
  emits: ["passWrite"],
  setup(__props, { emit: __emit }) {

const emit = __emit

// endregion

// region Variables

const password = ref("")
const isHidden = ref(true)
const inputType = computed(() => (isHidden.value ? "password" : "text"))
const iconName = computed(() => (isHidden.value ? Icons.SHOW : Icons.HIDE))
const iconClass = computed(() => (password.value ? "text-navy-base" : "text-inactive"))

// endregion

//region Functions

function eyeClick() {
  isHidden.value = !isHidden.value
}

//endregion

//region Setup Code

watchEffect(() => {
  emit("passWrite", password.value)
})

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(SfxInput, {
    modelValue: password.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
    type: inputType.value,
    label: _ctx.$t('sfxInput.password'),
    "hide-bottom-space": "",
    required: ""
  }, {
    append: _withCtx(() => [
      _createVNode(_component_q_icon, {
        name: iconName.value,
        onClick: eyeClick,
        type: "button",
        class: _normalizeClass(["q-field__focusable-action", iconClass.value])
      }, null, 8, ["name", "class"])
    ]),
    _: 1
  }, 8, ["modelValue", "type", "label"]))
}
}

})